import { render, staticRenderFns } from "./movement.vue?vue&type=template&id=377f256c&scoped=true"
import script from "./movement.vue?vue&type=script&lang=js"
export * from "./movement.vue?vue&type=script&lang=js"
import style0 from "./movement.vue?vue&type=style&index=0&id=377f256c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f256c",
  null
  
)

export default component.exports